import cn from 'classnames';
import { DropdownTriangle } from '#assets/ReactSvg.ts';
import buttonStyles from '../Button.module.css';
import styles from './SelectButton.module.css';

type Props = React.ComponentPropsWithRef<'button'> & {
  hasValue: boolean;
  isMenuOpen: boolean;
  hasError?: boolean;
  size?: 'xsmall' | 'small' | 'medium';
  icon?: React.ReactElement<React.ComponentProps<'svg'>>;
  variant?: 'secondary';
};

export const SelectButton = ({
  className,
  children,
  hasValue,
  hasError,
  isMenuOpen,
  icon,
  variant,
  size = 'medium',
  ...props
}: Props) => {
  const classes = cn(
    'border-focusable',
    'btn',
    styles.SelectButton,
    styles[`SelectButton___${size}` as const],
    buttonStyles[`Button___${size}` as const],
    {
      [styles.SelectButton___hasValue]: hasValue,
      [styles.SelectButton___isMenuOpen]: isMenuOpen,
      [styles.SelectButton___secondary]: variant === 'secondary',
      'has-error': hasError,
      // Keep "active" style while popover is open, when using secondary variant styles (e.g. network filter)
      'menu-btn-active': isMenuOpen && variant === 'secondary',
    },
    className
  );
  return (
    <button className={classes} type="button" {...props}>
      <span className="truncate flex gap-8 align-center">
        {icon}
        <span className="truncate">{children}</span>
      </span>
      <DropdownTriangle className="ml-16" height={6} width={10} />
    </button>
  );
};
